/* globals lp, editor */
var InvariantsHelper = require('./invariants-helper');
var _ = require('lodash');

(function() {
  var assert = lp.invariants.assert,
    register = lp.invariants.register,
    helper = InvariantsHelper;

  var _checkTransformBox = function() {
    //TODO: this should use assert rather than all these boolean checks
    if (editor.activeElement.type === 'lp-pom-image') {
      return _.isNull(editor.transformBox.elm) &&
        _.isNull(editor.sectionTransformBox.elm) &&
        editor.imageTransformBox.elm.id === editor.activeElement.id;
    } else if (editor.activeElement.type === 'lp-pom-block') {
      return _.isNull(editor.transformBox.elm) &&
        _.isNull(editor.imageTransformBox.elm) &&
        editor.sectionTransformBox.elm.id === editor.activeElement.id;
    } else {

      var isValidTransformBox = function(editor) {
        return ! _.isNull(editor.transformBox.elm) &&
          editor.transformBox.elm.id === editor.activeElement.id;
      };

      return _.isNull(editor.sectionTransformBox.elm) &&
        _.isNull(editor.imageTransformBox.elm) && isValidTransformBox(editor);
    }
  };

  register('CheckTransformBoxOnActiveElement', function() {
    if (helper.isNonRootElementSelectedAndPropertiesPanelVisible()) {
      return assert(_checkTransformBox(), "Active element state is not properly set.");
    } else {
      return true;
    }
  });
})();



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/editor/invariants/transform-box-invariants.js
// module id = 1078
// module chunks = 0